// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3gXdO","selected":"Chip_selected__J-gUN"};